module.exports = __webpack_public_path__ + "static/img/9.5bac3bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/zh/9.png
// module id = x30v
// module chunks = 0